import {
  UPDATE_URL,
  SET_PERCENT,
  SET_NEXT,
  GO_NEXT,
  GO_BACK,
  CANCEL_CLAIM,
  SUBMIT_AGAIN,
  PASS_NAV_MESSAGE,
  PASS_NAV_RESPONSE,
  CLEAR_NAV,
  PASS_NAV_CALLBACKS

} from '../actions/submitNavigationActions'

const SubmitNavigation = (state = {
  helpUrl: null,
  percent: null,
  pageNext: null,
  currentPage: '',
  pageStack: []
}, action) => {
  let isWelcomePageShown
  switch (action.type) {
    case UPDATE_URL:
      return Object.assign({}, state, {
        helpUrl: action.url
      })
    case SET_PERCENT:
      return Object.assign({}, state, {
        percent: action.percent
      })
    case SET_NEXT:
      return Object.assign({}, state, {
        pageNext: action.next,
        callBacks: action.callBacks
      })
    case GO_NEXT:
      let nextPS = state.pageStack.slice()
      nextPS.push(state.currentPage)
      return Object.assign({}, state, {
        currentPage: state.pageNext,
        pageStack: nextPS
      })
    case GO_BACK:
      let backPS = state.pageStack.slice()
      let currentPage = backPS.pop() || null
      isWelcomePageShown = window.localStorage.getItem('isWelcomePageShown')
      if (isWelcomePageShown === 'true' && (currentPage === null)) {
        currentPage = 'member'
      }
      return Object.assign({}, state, {
        currentPage: currentPage,
        pageStack: backPS,
        dialogMsg: null,
        dialogRsp: null
      })
    case CANCEL_CLAIM:
      isWelcomePageShown = window.localStorage.getItem('isWelcomePageShown')
      let _currentPage = null
      let _pageStack = []
      if (isWelcomePageShown === 'true') {
        _currentPage = 'member'
        _pageStack = [null, 'terms', 'member']
      }
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        helpUrl: null,
        percent: 0,
        pageNext: null,
        currentPage: _currentPage,
        pageStack: _pageStack
      })
    case SUBMIT_AGAIN:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        helpUrl: null,
        percent: 20,
        pageNext: null,
        currentPage: 'member',
        pageStack: [null, 'terms', 'member']
      })
    case PASS_NAV_MESSAGE:
      return Object.assign({}, state, {
        dialogMsg: action.message
      })
    case PASS_NAV_RESPONSE:
      return Object.assign({}, state, {
        dialogRsp: action.response
      })
    case CLEAR_NAV:
      return Object.assign({}, state, {
        dialogMsg: null,
        dialogRsp: null
      })
    case PASS_NAV_CALLBACKS: {
      return Object.assign({}, state, {
        callBacks: action.callBacks
      })
    }

    default:
      return state
  }
}

export default SubmitNavigation



// WEBPACK FOOTER //
// ./src/redux/reducers/submitNavigationReducer.js